import React from 'react';
import { useTheme } from '../ThemeContext';
import { useLang, LangToggle } from '../LanguageContext';
import { t } from '../i18n';

export default function SelecteurTheme({ onClose }) {
  const { theme, themeId, changerTheme, THEMES } = useTheme();

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.panel} onClick={e => e.stopPropagation()}>
        <div style={styles.header}>
          <div style={styles.titre}>🎨 Couleur du thème</div>
          <button style={styles.closeBtn} onClick={onClose}>✕</button>
        </div>
        <div style={styles.grid}>
          {THEMES.map(t => (
            <div key={t.id} style={{ ...styles.themeItem, ...(themeId === t.id ? { ...styles.themeItemActive, borderColor: t.couleur } : {}) }}
              onClick={() => { changerTheme(t.id); onClose(); }}>
              <div style={{ ...styles.themeDot, background: t.couleur }}>
                {themeId === t.id && <span style={styles.check}>✓</span>}
              </div>
              <div style={styles.themeNom}>{t.nom}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

const styles = {
  overlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 200, display: 'flex', alignItems: 'flex-end' },
  panel: { background: '#fff', width: '100%', maxWidth: 480, margin: '0 auto', borderRadius: '20px 20px 0 0', padding: '20px 16px 30px' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 },
  titre: { fontSize: 15, fontWeight: 600, color: '#1C2833' },
  closeBtn: { background: '#f5f5f5', border: 'none', borderRadius: '50%', width: 30, height: 30, cursor: 'pointer' },
  grid: { display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 10 },
  themeItem: { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6, padding: '12px 8px', borderRadius: 12, border: '2px solid #eee', cursor: 'pointer', transition: 'all 0.15s' },
  themeItemActive: { border: '2px solid', background: '#f9f9f9' },
  themeDot: { width: 40, height: 40, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 2px 8px rgba(0,0,0,0.15)' },
  check: { color: '#fff', fontSize: 18, fontWeight: 700 },
  themeNom: { fontSize: 11, color: '#666', textAlign: 'center', fontWeight: 500 },
};
